import React, { useContext, useEffect, useState } from 'react';
import { Modal, Checkbox } from 'antd';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import { KpiMetricType, priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';

type KPIModalProps = {
    visible: boolean;
    closeModal: () => void;
    kpiMetrics: Array<KpiMetricType>;
};

const AddKPIModal = ({ visible, closeModal, kpiMetrics }: KPIModalProps) => {
    const [tempCheckedValues, setTempCheckedValues] = useState<number[]>(setSelectedKpi);

    const { setSelectedKpiValues, defaultKpiMetrics } = useContext(priceSimulatorDataContext);

    useEffect(() => {
        setTempCheckedValues(setSelectedKpi);
    }, [visible]);

    const onApplyChange = () => {
        setSelectedKpiValues([...tempCheckedValues]);
        closeModal();
    };

    const onResetClick = () => {
        setSelectedKpiValues(defaultKpiMetrics);
        closeModal();
    };

    const handleCheckboxChange = (checkedList: any) => {
        setTempCheckedValues(checkedList);
    };

    function setSelectedKpi() {
        return kpiMetrics.filter((item: any) => item.selected).map((item: any) => item.key);
    }

    return (
        <StyledModal
            open={visible}
            title="Target KPIs"
            onCancel={closeModal}
            footer={null}
            width={'30%'}
            className="rounded "
            centered
        >
            <div className="border border-borderLinePurpuleAlt rounded overflow-hidden">
                <div className=" border-b border-borderLinePurpuleAlt p-4 bg-bgBackground font-bold text-purpleFont font-xs">
                    Add more KPI
                </div>
                <Checkbox.Group className="w-full" value={tempCheckedValues} onChange={handleCheckboxChange}>
                    <div className="w-full overflow-y-scroll max-h-96 ">
                        {kpiMetrics.map((kpi, index) => (
                            <div
                                key={kpi.value}
                                className={`font-medium p-4 text-greyFont w-full  border-borderLinePurpuleAlt ${
                                    kpiMetrics.length - 1 !== index ? ' border-b' : ''
                                }`}
                            >
                                <Checkbox value={kpi.key} checked={tempCheckedValues.includes(kpi.key)}>
                                    {kpi.name}
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                </Checkbox.Group>
            </div>
            <div className="flex justify-end pt-6 font-bold">
                <button
                    type="button"
                    className="mr-2 px-6 py-1 rounded cursor-pointer text-purpleFont bg-white border border-purpleFont font-xxs"
                    onClick={onResetClick}
                >
                    Reset
                </button>
                <button
                    type="button"
                    className="text-white  px-6 py-1 rounded cursor-pointer  bg-purpleFont border border-purpleFont font-xxs"
                    onClick={onApplyChange}
                >
                    Apply
                </button>
            </div>
        </StyledModal>
    );
};

export default AddKPIModal;

const StyledModal = styled(Modal)`
    .ant-modal-title {
        ${tw`text-subHeaderColor`}
    }

    .ant-modal-close-x span svg {
        fill: '#140B1D';
    }

    .ant-modal-header {
        border: 0px;
    }

    .ant-modal {
        ${tw`w-1/3`}
    }

    .ant-modal-body {
        ${tw`pt-0`}
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        ${tw`bg-purpleFont border-purpleFont`}
    }
`;
